import { useTranslation } from 'react-i18next'

import { CoinsIcon } from '@phosphor-icons/react'

import { CardTitle, Drawer } from '@reveni-io/reveni-ui'

import EditTransactionAmount from '@/returns/components/EditTransactionAmount/EditTransactionAmount'

const EditTransactionAmountDrawer = ({
  show,
  onClose,
  lineItems,
  concepts,
  currency,
  refundMethods,
  refundMethod,
  onSave,
  returnId,
  loading,
  editable,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle Icon={CoinsIcon}>{t('Editar resultado transacción')}</CardTitle>
      <EditTransactionAmount
        show={show}
        onClose={onClose}
        lineItems={lineItems}
        concepts={concepts}
        currency={currency}
        refundMethods={refundMethods}
        refundMethod={refundMethod}
        onSave={onSave}
        returnId={returnId}
        loading={loading}
        editable={editable}
      />
    </Drawer>
  )
}

export default EditTransactionAmountDrawer
